import { motion } from 'framer-motion';
import { FaLinkedin, FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { Mail, MapPin, Phone } from 'lucide-react';

const LOGO_URL = '/img/logo-wingfold.png';

export const Footer = () => {
  return (
    <footer className="relative bg-[#080808] text-white overflow-hidden border-t border-white/5">
      {/* Decorative gradient */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full opacity-10" style={{
        background: 'radial-gradient(circle, rgba(184, 146, 63, 0.5) 0%, transparent 70%)',
        filter: 'blur(80px)'
      }} />
      <div className="absolute bottom-0 left-0 w-96 h-96 rounded-full opacity-10" style={{
        background: 'radial-gradient(circle, rgba(139, 26, 42, 0.5) 0%, transparent 70%)',
        filter: 'blur(80px)'
      }} />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-20">
        <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-12 mb-16">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="Wingfold" 
                className="h-14 w-14 object-contain"
              />
              <span className="font-display text-2xl font-medium tracking-tight">
                Wingfold
              </span>
            </div>
            <p className="font-display text-2xl lg:text-3xl font-light italic text-gold mb-4 max-w-md leading-tight">
              "Marcas que despegan, resultados que impactan."
            </p>
            <p className="font-sans text-sm text-white/50 max-w-md leading-relaxed">
              Performance marketing impulsado por data. Direct buying, programmatic y creatividad
              para escalar marcas en Europa y LATAM.
            </p>
          </div>

          <div>
            <h3 className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/40 mb-6">
              Contacto
            </h3>
            <div className="space-y-4">
              <a href="mailto:cristina.castillo@wingfold.es" className="flex items-center gap-3 group text-white/70 hover:text-gold transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <span className="font-sans text-sm">cristina.castillo@wingfold.es</span>
              </a>
              <a href="tel:+34625833080" className="flex items-center gap-3 group text-white/70 hover:text-gold transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <span className="font-sans text-sm">+34 625 833 080</span>
              </a>
              <div className="flex items-center gap-3 text-white/70" data-testid="footer-location">
                <MapPin className="w-4 h-4 flex-shrink-0" />
                <span className="font-sans text-sm">Madrid, España</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/40 mb-6">
              Síguenos
            </h3>
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/company/113245192"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full border border-white/10 hover:border-gold hover:bg-gold flex items-center justify-center transition-all duration-300 group"
                data-testid="footer-linkedin"
              >
                <FaLinkedin className="w-4 h-4 text-white/70 group-hover:text-black transition-colors" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full border border-white/10 hover:border-gold hover:bg-gold flex items-center justify-center transition-all duration-300 group"
                data-testid="footer-instagram"
              >
                <FaInstagram className="w-4 h-4 text-white/70 group-hover:text-black transition-colors" />
              </a>
              <a
                href="https://wa.me/34625833080?text=Hola%20Wingfold!%20Vi%20t%C3%BA%20p%C3%A1gina%20web%20y%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n."
                target="_blank"
                rel="noopener noreferrer"
                className="w-11 h-11 rounded-full border border-white/10 hover:border-gold hover:bg-gold flex items-center justify-center transition-all duration-300 group"
                data-testid="footer-whatsapp"
              >
                <FaWhatsapp className="w-4 h-4 text-white/70 group-hover:text-black transition-colors" />
              </a>
            </div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4"
        >
          <p className="font-sans text-xs text-white/40">
            &copy; {new Date().getFullYear()} L&C Digital & Consulting, S.L. — NIF B22652069
          </p>
          <nav className="flex flex-wrap gap-4 justify-center md:justify-end">
            <a href="/aviso-legal" className="font-sans text-xs text-white/40 hover:text-gold transition-colors">Aviso Legal</a>
            <a href="/privacidad" className="font-sans text-xs text-white/40 hover:text-gold transition-colors">Privacidad</a>
            <a href="/cookies" className="font-sans text-xs text-white/40 hover:text-gold transition-colors">Cookies</a>
          </nav>
        </motion.div>
      </div>
    </footer>
  );
};
